import React, { useState } from "react";
import PrimaryButton from "./Button/PrimaryButton";
import * as utils from "../utils/utils";

export default function UploadImage({
  formikState,
  imageLogData,
  setImageLogData,
}) {
  const handleImageSelect = async () => {
    const imageData = await utils?.fileSelectHandler("image/*");
    if (imageData?.fileDetail) {
      formikState?.setFieldValue("signaturImage", imageData?.fileDetail);
      setImageLogData(imageData);
    }
  };

  return (
    <div className="flex gap-5">
      <PrimaryButton
        size={"large"}
        name={"Upload Signature"}
        height={"50px"}
        borderRadius={"10px"}
        handleOnClick={handleImageSelect}
        width={"50%"}
      />
      {/* Display the file name if available */}
      {imageLogData ? (
        <span className="text-black mt-2">
          {imageLogData?.fileDetail?.name || "No file selected"}
        </span>
      ) : (
        <span className="text-black mt-2">No file selected</span>
      )}
    </div>
  );
}
